export type ConfigurationTable = {
  alias: string;
  nodeKey: string;
};

export function parseConfigurationTables(value?: string): ConfigurationTable[] {
  if (!value?.trim()) return [];

  return value.split('|').flatMap((entry) => {
    const trimmed = entry.trim();
    const separator = trimmed.lastIndexOf('_');
    if (separator <= 0 || separator === trimmed.length - 1) return [];

    const alias = trimmed.slice(0, separator).trim();
    const nodeKey = trimmed.slice(separator + 1).trim();
    return alias && nodeKey ? [{ alias, nodeKey }] : [];
  });
}
